
import Vue from 'vue';
import RunnitCarousel from './RunnitCarousel.vue';
import { RUNNIT_TYPE, RunnitNodeDef } from '@run-diffusion/shared';
import { ROUTER } from '@/router/constants';
import { RunnitsCRUDMixin, TeamUserMixin } from '@/mixins';
import { mapState } from 'vuex';
import { KIT_TYPE } from './constants';
import { analytics, EVENTS } from '@/services/analytics';
import { KitsMixin } from '@/mixins/KitsMixin';

export default Vue.extend({
	name: 'RunnitIntentionsBar',
	mixins: [
		RunnitsCRUDMixin,
		TeamUserMixin,
		KitsMixin,
	],
	data () {
		return {
		}
	},
	computed: {
		...mapState([
			'user',
		]),
		intentions () {
			const intentions: {
				label: string,
				imgUrl: string,
				description: string,
				nodeDef?: Partial<RunnitNodeDef>,
				kitType?: string,
				routeTo?: string,
				videoSrcWebm?: string,
				videoSrcMp4?: string,
			}[] = [
					{
						label: 'Image',
						imgUrl: 'https://cdn.rundiffusion.com/file/rd-web-assets/videos/_runnit_intentions_bar_image.avif',
						videoSrcWebm: 'https://cdn.rundiffusion.com/file/rd-web-assets/videos/runnit_intentions_bar_image.webm',
						description: 'Generate an image using a text prompt or another image as input.',
						kitType: KIT_TYPE.image,
					},
					{
						label: 'Video',
						imgUrl: 'https://cdn.rundiffusion.com/file/rd-web-assets/videos/_runnit_intentions_bar_video_image.avif',
						videoSrcWebm: 'https://cdn.rundiffusion.com/file/rd-web-assets/videos/runnit_intentions_bar_video_vid.webm',
						description: 'Create a short video from a text prompt or existing image.',
						kitType: KIT_TYPE.video,
					},
					{
						label: 'Edit',
						imgUrl: 'https://cdn.rundiffusion.com/file/rd-web-assets/videos/_runnit_intentions_bar_edit_image.avif',
						videoSrcWebm: 'https://cdn.rundiffusion.com/file/rd-web-assets/videos/runnit_intentions_bar_edit_vid.webm',
						description: 'Make changes to an existing image with natural language prompts.',
						kitType: KIT_TYPE.imageEdit,
					},
					...(this.hasViewTrainPermission ? [
						{
							label: 'Train',
							imgUrl: 'https://cdn.rundiffusion.com/file/rd-web-assets/videos/_runnit_intentions_bar_train_img.avif',
							videoSrcWebm: 'https://cdn.rundiffusion.com/file/rd-web-assets/videos/runnit_intentions_bar_train_vid.webm',
							description: 'Train a custom AI on your intellectual property model for use in other tools.',
							routeTo: ROUTER.RUNNITS_MODELS_LIST,
						},
					] : []),
					{
						label: 'Upscale',
						imgUrl: 'https://cdn.rundiffusion.com/file/rd-web-assets/videos/_runnit_intentions_bar_upscale_img.avif',
						videoSrcWebm: 'https://cdn.rundiffusion.com/file/rd-web-assets/videos/runnit_intentions_bar_upscale_vid.webm',
						description: 'Improve the quality and resolution of an image. 4k to 8k and beyond.',
						kitType: KIT_TYPE.upscale,
					},
					// {
					// 	label: 'Vector',
					// 	imgUrl: 'https://firebasestorage.googleapis.com/v0/b/image-ai-cb35d.appspot.com/o/assets%2Fintentions-bar%2FVector-Intention-003.png?alt=media&token=b34f83a2-eb19-4b8f-bb98-3d3affcc857e',
					// 	description: 'Create a vector graphic using a text prompt for scalability',
					// 	nodeDef: {
					// 		id: 'nGL2wB5LEnmWBW72zk3K',
					// 		title: 'SVG Generator'
					// 	} as RunnitNodeDef
					// },
					// {
					// 	label: 'Workflow',
					// 	imgUrl: 'https://firebasestorage.googleapis.com/v0/b/image-ai-cb35d.appspot.com/o/assets%2Fintentions-bar%2FWorkflow-Intention-002.png?alt=media&token=e95ccb72-e310-473f-92bd-365d54beb6f6',
					// 	description: 'Create a template to automate a sequence of tasks',
					// 	routeTo: [PUT ROUTE HERE],
					// },
				];
			// A tile backed by a Kit disappears with the Kit: unpublishing one
			// must not leave a tile that navigates nowhere.
			return intentions.filter((intention) => (
				!intention.kitType || this.navigableKits.some((kit) => kit.id === intention.kitType)
			));
		}
	},
	methods: {
		onIntentionClick (intention) {
			analytics.track(EVENTS.HOME_INTENTION_CLICKED, {
				intention_label: this._get(intention, 'label', null),
				has_node_def: !!(this._get(intention, 'nodeDef') || this._get(intention, 'kitType')),
				node_def_id: this._get(intention, 'nodeDef.id', null),
			});
			if (intention.kitType) {
				// Resolved at click, not at paint: the tile can render before the
				// runnitKits binding lands, and an unresolved Kit simply does not
				// navigate rather than routing to a tool that does not exist.
				const toolId = this.getKitEntryNodeDefId(intention.kitType);
				if (!toolId) return;

				this.routerPush(this.$route, this.$router, {
					name: ROUTER.RUNNIT_REROUTE,
					query: {
						toolId,
						kit: intention.kitType,
					},
				});
				return;
			}
			if (intention.nodeDef) {
				this.onAddRunnitClick(intention.nodeDef, RUNNIT_TYPE.SINGLE_TOOL);
				return;
			}
			if (intention.routeTo) {
				this.routerPush(this.$route, this.$router, { name: intention.routeTo });
				return;
			}
		},
	},
	components: {
		RunnitCarousel,
	}
});
